import axios from "axios";
import { BASE_URL as baseURL } from "./config";

function createFetch(token) {
  const headers = {
    authorization: token,
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
    "Access-Control-Allow-Headers": "Content-Type"
  };

  return axios.create({
    headers,
    baseURL,
    timeout: 120000
  });
}

/**
 * Creates Helper for HTTP Requests
 * @param token
 */
export default function(token) {
  return createFetch(token);
}



// WEBPACK FOOTER //
// ./src/lib/httpRequest.js